import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import {
  ButtonListItem,
  ContentListItem,
  LinkListItem,
} from '@widgets/UserProfile/types'
import Blink from '@components/Blink'

interface ContentListItemComponentProps {
  children: ReactNode[]
  item: ContentListItem
}

const commonStyles = css`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: ${spacing8};
    width: 100%;
    box-sizing: border-box;
    height: 48px;
  `}
`

const StyledContentItemButton = styled.button`
  ${commonStyles};
  appearance: none;
  text-decoration: none;
  border: 0;
  cursor: pointer;
  background: none;
  padding: 0;
`

const StyledContentItemLink = styled(Blink)`
  ${commonStyles};
  text-decoration: none;
  cursor: pointer;
`

const StyledNonClickableContentItem = styled.div`
  ${commonStyles};
`

const checkHasLink = (item: ContentListItem): item is LinkListItem =>
  item.type === 'link' && !!item?.link

const checkHasButton = (item: ContentListItem): item is ButtonListItem =>
  item.type === 'button' && !!item?.onClick

const ContentListItemClickableWrapper: FunctionComponent<
  ContentListItemComponentProps
> = ({ children, item }) => {
  const hasLink = checkHasLink(item)
  const hasButton = checkHasButton(item)
  if (hasLink) {
    return (
      <StyledContentItemLink {...item.link} onClick={item.onClick}>
        {children}
      </StyledContentItemLink>
    )
  }
  if (hasButton) {
    return (
      <StyledContentItemButton type="button" onClick={item.onClick}>
        {children}
      </StyledContentItemButton>
    )
  }

  return (
    <StyledNonClickableContentItem>{children}</StyledNonClickableContentItem>
  )
}

export default ContentListItemClickableWrapper
